import BasicLayout from "./BasicLayout";
import axiosClient from "axios-client.js";
import { activeMaintenanceValue } from "utils/maintenance";

const Step4 = ({ state, setState, setLoad, setMessage }) => {
    function selectType(type) {
        var licensesState = [];
        state.data.licenses.forEach((license, idx) => {
            licensesState[idx] = {
                code: license.code,
                qty: license.qty ? license.qty : 0,
                active: license.active,
            };
        });

        axiosClient
            .get(`/activation/${state.code}/licenses`, {
                params: {
                    server_type: state.type,
                    data: {
                        licenses: licensesState,
                        maintenance: {
                            qty: type,
                        },
                    },
                },
            })
            .then(({ data }) => {
                setLoad(false);
                setState((state) => ({
                    ...state,
                    data: {
                        ...state.data,
                        licenses: Object.keys(data?.data?.licenses)
                            .map((lic) => {
                                return data?.data?.licenses[lic];
                            })
                            .sort((a, b) => (a.order > b.order ? 1 : -1)),
                        maintenance: activeMaintenanceValue(
                            data?.data?.maintenance
                                ? data?.data?.maintenance
                                : 0
                        ),
                        maintenance_data: data?.data?.maintenance,
                        total: data?.data?.total,
                    },
                }));
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }

    return (
        <BasicLayout
            title="Tipologia maintenance"
            subtitle={
                <>
                    La maintenance è un servizio annuale obbligatorio che ti
                    assicura nel tempo un corretto funzionamento della
                    piattaforma Proxima Onsite. <br />
                    Comprende aggiornamenti software continui, miglioramenti
                    funzionali e aggiornamenti di sicurezza: aspetti
                    fondamentali per mantenere la tua piattaforma di
                    collaboration sempre affidabile, performante e protetta.
                </>
            }
            titleTwo="Informazioni utili"
            subtitleTwo={
                <>
                    <span className="inline-block text-[14.5px] text-gray-800 dark:text-white">
                        Il primo anno di maintenance è incluso nel prezzo di
                        acquisto.
                    </span>
                    <span className="inline-block text-[14.5px] text-gray-800 dark:text-white">
                        A partire dal secondo anno, il piano maintenance è
                        obbligatorio e a pagamento.
                    </span>
                </>
            }
            titleThree="Il tuo piano maintenance"
            subtitleThree={
                <>
                    Scegli il piano maintenance più adatto alle esigenze del tuo
                    cliente finale in base alla durata della copertura.
                </>
            }
            content={
                <div className="mt-5 grid grid-cols-1 gap-6 md:grid-cols-4">
                    <div
                        onClick={() => selectType(0)}
                        className={
                            (state?.data?.maintenance === "0" ||
                            state?.data?.maintenance === 0
                                ? "border-2 border-blue-500 text-blue-500"
                                : "") +
                            ` !z-5 relative flex cursor-pointer items-stretch rounded-[8px] bg-white bg-clip-border py-6 px-4 text-center text-gray-800 shadow-lg shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none md:py-4 md:px-6`
                        }
                    >
                        <div className="flex cursor-pointer flex-col justify-center gap-2">
                            <p className="self-center text-xl font-medium italic leading-none">
                                1° anno incluso
                            </p>
                            <p className="self-center text-sm font-medium leading-none dark:text-white">
                                Piano maintenance compreso nel prezzo di
                                acquisto
                            </p>
                        </div>
                    </div>

                    <div
                        onClick={() => selectType(1)}
                        className={
                            (state?.data?.maintenance === "1" ||
                            state?.data?.maintenance === 1
                                ? "border-2 border-blue-500 text-blue-500"
                                : "") +
                            ` !z-5 relative flex cursor-pointer items-stretch rounded-[8px] bg-white bg-clip-border py-6 px-4 text-center text-gray-800 shadow-lg shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none md:py-4 md:px-6`
                        }
                    >
                        <div className="flex cursor-pointer flex-col justify-center gap-2">
                            <p className="self-center text-xl font-medium italic leading-none">
                                +1 anno (totale 2 anni)
                            </p>
                            <p className="self-center text-sm font-medium leading-none dark:text-white">
                                Estensione del piano maintenance per un altro
                                anno.
                            </p>
                            <p className="m-0 cursor-pointer font-bold">
                                €{" "}
                                {state.data.maintenance_data["1"].price.toFixed(
                                    2
                                )}
                            </p>
                        </div>
                    </div>

                    <div
                        onClick={() => selectType(3)}
                        className={
                            (state?.data?.maintenance === "3" ||
                            state?.data?.maintenance === 3
                                ? "border-2 border-blue-500 text-blue-500"
                                : "") +
                            ` !z-5 relative flex cursor-pointer items-stretch rounded-[8px] bg-white bg-clip-border py-6 px-4 text-center text-gray-800 shadow-lg shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none md:py-4 md:px-6`
                        }
                    >
                        <div className="flex cursor-pointer flex-col justify-center gap-2">
                            <p className="self-center text-xl font-medium italic leading-none">
                                +3 anni (totale 4 anni)
                            </p>
                            <p className="self-center text-sm font-medium leading-none dark:text-white">
                                Estensione del piano maintenance per tre anni.{" "}
                                <br />È la soluzione che ti suggeriamo per una
                                gestione a medio-lungo termine.
                            </p>
                            <p className="m-0 cursor-pointer font-bold">
                                €{" "}
                                {state.data.maintenance_data["3"].price.toFixed(
                                    2
                                )}
                            </p>
                        </div>
                    </div>

                    <div
                        onClick={() => selectType("lifetime")}
                        className={
                            (state?.data?.maintenance === "lifetime"
                                ? "border-2 border-blue-500 text-blue-500"
                                : "") +
                            ` !z-5 relative flex cursor-pointer items-stretch rounded-[8px] bg-white bg-clip-border py-6 px-4 text-center text-gray-800 shadow-lg shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none md:py-4 md:px-6`
                        }
                    >
                        <div className="flex cursor-pointer flex-col justify-center gap-2">
                            <p className="self-center text-xl font-medium italic leading-none">
                                lifetime
                            </p>
                            <p className="self-center text-sm font-medium leading-none dark:text-white">
                                Piano di maintenance senza scadenza temporale.{" "}
                                <br /> È la soluzione che ti suggeriamo per le
                                installazioni definitive.
                            </p>
                            <p className="m-0 cursor-pointer font-bold">
                                €{" "}
                                {state.data.maintenance_data[
                                    "lifetime"
                                ].price.toFixed(2)}
                            </p>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default Step4;
